"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Twitter = function Twitter(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "twitter",
    viewBox: "0 0 32 32"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-172.000000, -518.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, react_1["default"].createElement("g", {
    id: "Group-11",
    transform: "translate(60.000000, 518.000000)"
  }, react_1["default"].createElement("g", {
    id: "Twitter",
    transform: "translate(112.000000, 0.000000)"
  }, react_1["default"].createElement("path", {
    d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M15.5208018,13.0050004 L15.5543767,13.5586365 L14.9947933,13.4908443 C12.9579095,13.2309743 11.1784341,12.3496761 9.66755872,10.8695469 L8.92890853,10.1351317 L8.73865019,10.6774691 C8.33575008,11.8864295 8.59315845,13.1631821 9.43253365,14.021883 C9.88020043,14.4964283 9.77947541,14.5642204 9.00725024,14.2817531 C8.73865019,14.1913635 8.50362512,14.1235713 8.48124176,14.1574674 C8.40290011,14.2365582 8.67150016,15.2647396 8.88414187,15.6714926 C9.17512528,16.2364274 9.76828373,16.7900635 10.4174006,17.1177257 L10.9657924,17.3775957 L10.3166755,17.3888944 C9.68994208,17.3888944 9.66755872,17.4001931 9.73470875,17.6374657 C9.95854213,18.371881 10.842684,19.1514909 11.8275509,19.4904518 L12.5214344,19.7277244 L11.9170843,20.0892827 C11.0217507,20.6090227 9.96973381,20.9027888 8.91771691,20.9253862 C8.41409179,20.9366849 8,20.9818797 8,21.0157758 C8,21.1287627 9.36538363,21.7614897 10.1599922,22.010061 C12.5438177,22.7444763 15.37531,22.4281127 17.5017272,21.1739575 C19.0126026,20.2813605 20.5234779,18.5074653 21.2285531,16.7900635 C21.6090698,15.8748692 21.9895866,14.2026622 21.9895866,13.4004548 C21.9895866,12.8807148 22.0231616,12.8129226 22.6498951,12.1914943 C23.0192202,11.8299361 23.3661619,11.4344817 23.4333119,11.3214947 C23.5452286,11.1068195 23.534037,11.1068195 22.9632618,11.2988973 C22.0119699,11.6378582 21.8776699,11.5926634 22.34772,11.0842221 C22.6946618,10.7226638 23.1087535,10.0673395 23.1087535,9.87526165 C23.1087535,9.8413656 22.9408785,9.89785904 22.7506201,9.99954731 C22.54917,10.1125343 22.1015033,10.2820147 21.7657532,10.383703 L21.161403,10.5757808 L20.6130113,10.2029238 C20.3108362,9.99954731 19.8855527,9.77357339 19.6617194,9.70578123 C19.0909443,9.54759947 18.217994,9.57019685 17.7031773,9.750976 C16.3042186,10.2594173 15.4200767,11.570066 15.5208018,13.0050004 Z",
    id: "Combined-Shape"
  }))))));
};

exports["default"] = Twitter;